<template>
  <div class="Keep2Add">
    <i @click="showModal" class="fa fa-plus"></i>
    <component-modal v-show="condition.condition" transition="expand">

      <template slot="title">
        先生検索
      </template>

      <div slot="body" class="wrapper">

        <div class="mail-list">
          <table-c>
            <tr-c slot="tr-th">
              <td-c><input type="text" v-model="search.id" @keyup="searchTable()" placeholder="id"></td-c>
              <td-c><input type="text" v-model="search.tel1" @keyup="searchTable()" placeholder="tel1"></td-c>
              <td-c><input type="text" v-model="search.tel2" @keyup="searchTable()" placeholder="tel2"></td-c>
              <td-c><input type="text" v-model="search.name" @keyup="searchTable()" placeholder="name"></td-c>
              <td-c><input type="text" v-model="search.kana" @keyup="searchTable()" placeholder="kana"></td-c>
            </tr-c>

            <tr-c slot="tr-td" @click.native="push(list)" v-for="(list, index) in tutors" :key="index.id" class="tr_hover">
              <td-c>{{list.id}}</td-c>
              <td-c>{{list.tel1}}</td-c>
              <td-c>{{list.tel2}}</td-c>
              <td-c>{{list.f_name}} {{list.l_name}}</td-c>
              <td-c>{{list.f_name_kana}} {{list.l_name_kana}}</td-c>
            </tr-c>

            <tr-c slot="tr-td">
              <th-c style="border-right: 0">追加対象</th-c>
              <th-c style="border-right: 0"></th-c>
              <th-c style="border-right: 0"></th-c>
              <th-c style="border-right: 0"></th-c>
              <th-c></th-c>
            </tr-c>

            <tr-c style="height: 25px" slot="tr-td">
              <td-c>{{modal.list.keep_id2}}</td-c>
              <td-c>{{modal.list.keep_tel2}}</td-c>
              <td-c>{{modal.list.keep_f_name2}}</td-c>
              <td-c>{{modal.list.keep_l_name2}}</td-c>
            </tr-c>
          </table-c>
        </div>

      </div>

      <div class="footer" slot="footer">
        <btn @click.native="showModal">戻る</btn>
      </div>

    </component-modal>
  </div>
</template>

<script>
import axios from 'axios'
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/tutors/search?limit=' + 5

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'tutor',
  pageNames: 'tutors'
}

export default {
  props: {
    modal: Object
  },
  name: 'Keep2Add',
  data () {
    return {
      condition: {
        condition: false
      },

      search: {
        id: '',
        tel1: '',
        tel2: '',
        name: '',
        kana: ''
      }
    }
  },
  computed: {
    tutors () {
      return this.$store.getters.tutors
    }
  },
  watch: {
  },
  methods: {
    showModal () {
      this.condition.condition = !this.condition.condition
    },

    push (list) {
      this.modal.list.keep_id2 = list.id
      this.modal.list.keep_tel2 = list.tel1
      this.modal.list.keep_f_name2 = list.f_name
      this.modal.list.keep_l_name2 = list.l_name
    },

    searchTable (e) {
      let search = this.search
      var store = this.$store
      var params = {}
      function searchTable () {
        // students
        var paramsList = [
          'id',
          'tel1',
          'tel2',
          'name',
          'kana'
        ]
        paramsList.forEach(function (e) {
          if (search[e]) {
            params[e] = search[e]
          }
        })
        axios.get(obj.url, {params: params, withCredentials: true})
        .then(response => {
        // success callback
          console.log(response)
          store.state.list.tutors = response.data.tutor
          store.state.max = response.data.max
          obj.searchUrl = response.request.responseURL
          obj.COUNT = 1
        }, (response) => {
        // error callback
        })
      }

      if (obj.TIMER) {
        clearTimeout(obj.TIMER)
        obj.TIMER = setTimeout(searchTable, obj.wait)
        return
      }
      obj.TIMER = setTimeout(searchTable, obj.wait)
    }
  },
  mounted () {
  }
}
</script>

<style lang='scss' scoped>
.Keep2Add {
  display: inline;
  margin-left: 5px;
}

.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.expand-transition {
  transition: all .3s ease;
  height: 30px;
  padding: 10px;
  background-color: #eee;
  overflow: hidden;
}
.expand-enter, .expand-leave {
  height: 0;
  padding: 0 10px;
  opacity: 0;
}
.wrapper {
  display: flex;
  flex-flow: column;
  max-height: 340px;
}
.mail-list {
  overflow: scroll;
  margin: 5px 0;
}
.table {
  margin: 0;
}
.footer {
  width: 100%;
  display: flex;
  .m-btn + .m-btn {
    margin-top: 0;
  }
}
</style>

<style lang="scss">
.Keep2Add {
}
</style>



// WEBPACK FOOTER //
// Keep2Add.vue?03d54a54